module.exports = __webpack_public_path__ + "img/no_featured.525f45a9.svg";